import { Route, Routes } from 'react-router-dom';
import { userModel } from 'entities/user';
import { mode, ProtectedRoute, routes, useShallowSelector } from 'shared';

import { BuyPage } from './buy';
import { ConnectPage } from './connect';
import { KycPage } from './kyc';
import { SwapPage } from './swap';

const modeConfig = {
  swap: {
    path: routes.swap.path,
    component: SwapPage,
  },
  buy: {
    path: routes.buy.path,
    component: BuyPage,
  },
};

const { path, component: ModePage } = modeConfig[mode];

export const Routing = () => {
  const { isKycApproved, isAuthenticated } = useShallowSelector(userModel.selectors.selectIsAuthenticated);

  return (
    <Routes>
      <Route
        element={
          <ProtectedRoute
            outlet={<ConnectPage />}
            isRedirect={isAuthenticated}
            redirectTo={isKycApproved ? path : routes.kyc.path}
          />
        }
        path={routes.connect.path}
      />
      <Route
        element={
          <ProtectedRoute
            outlet={<KycPage />}
            isRedirect={!isAuthenticated || (isAuthenticated && isKycApproved)}
            redirectTo={path}
          />
        }
        path={routes.kyc.path}
      />
      <Route
        element={
          <ProtectedRoute
            outlet={<ModePage />}
            isRedirect={!isAuthenticated || !isKycApproved}
            redirectTo={isAuthenticated ? routes.kyc.path : routes.connect.path}
          />
        }
        path={path}
      />
      <Route element={<ProtectedRoute outlet={<ModePage />} isRedirect redirectTo={path} />} path="*" />
    </Routes>
  );
};
